import { useContext } from 'react';
import DataContext from 'src/contexts/DataContext';

const useData = () => useContext(DataContext);

export default useData;
